import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Divider } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { CartPropType } from './CartSummary.propTypes';
import CartItemSummary from './components/CartItemSummary';
import CartTotalSummary from './components/CartTotalSummary';
import EmptyCartMessage from './components/EmptyCartMessage';
import HeaderActions from './components/HeaderActions';
import SpecialInstructions from './components/SpecialInstructions';
import SpecialInstructionsSummary from './components/SpecialInstructionsSummary';
import { CurrencyNumberPropType } from '../../../services/proptypes';
import './CartSummary.css';
var defaultProps = {
  header: null,
  readOnly: false,
  displayHeaderActions: false,
  children: null,
  onUpdateCartItemQuantity: function onUpdateCartItemQuantity() {
    return null;
  },
  onUpdateCartItem: function onUpdateCartItem() {
    return null;
  },
  onDeleteCartItem: function onDeleteCartItem() {
    return null;
  },
  getOrderItemOptions: null,
  onSpecialInstructionsChange: null,
  tip: '0.00',
  onTipChange: null,
  loading: false
};
function CartSummary(_ref) {
  var header = _ref.header,
    cart = _ref.cart,
    onUpdateCartItemQuantity = _ref.onUpdateCartItemQuantity,
    onUpdateCartItem = _ref.onUpdateCartItem,
    onDeleteCartItem = _ref.onDeleteCartItem,
    onSpecialInstructionsChange = _ref.onSpecialInstructionsChange,
    getOrderItemOptions = _ref.getOrderItemOptions,
    loading = _ref.loading,
    readOnlyProp = _ref.readOnly,
    displayHeaderActions = _ref.displayHeaderActions,
    tip = _ref.tip,
    onTipChange = _ref.onTipChange,
    children = _ref.children;
  var lineItems = cart.line_items,
    taxTotal = cart.tax_total,
    taxDetails = cart.tax_details,
    fulfillmentTotal = cart.fulfillment_total,
    fulfillmentDetails = cart.fulfillment_details,
    feeTotal = cart.fee_total,
    feeDetails = cart.fee_details,
    total = cart.total,
    subTotal = cart.sub_total;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    showItems = _useState2[0],
    setShowItems = _useState2[1];
  var _useState3 = useState(readOnlyProp),
    _useState4 = _slicedToArray(_useState3, 2),
    readOnly = _useState4[0],
    setReadOnly = _useState4[1];
  var _ref2 = cart || {},
    specialInstructions = _ref2.instructions;
  function toggleShowItems() {
    setShowItems(function (prevState) {
      return !prevState;
    });
  }
  function toggleReadOnly() {
    setReadOnly(function (prevState) {
      return !prevState;
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "cart-summary-container"
  }, !_isEmpty(header) && /*#__PURE__*/React.createElement("div", {
    className: "header-container"
  }, header), displayHeaderActions && /*#__PURE__*/React.createElement(HeaderActions, {
    totalItems: lineItems.length,
    onShowItems: toggleShowItems,
    onEditItems: toggleReadOnly,
    showItems: showItems,
    editItems: !readOnly
  }), showItems && /*#__PURE__*/React.createElement("div", {
    className: "cart-items-container"
  }, !_isEmpty(lineItems) ? lineItems.map(function (lineItem, index) {
    var lineItemUuid = lineItem.uuid;
    return /*#__PURE__*/React.createElement(CartItemSummary, {
      item: lineItem,
      onUpdateQuantity: function onUpdateQuantity(type) {
        return onUpdateCartItemQuantity(type, index);
      },
      onUpdate: function onUpdate(newItem) {
        return onUpdateCartItem(newItem, index);
      },
      onDelete: function onDelete() {
        return onDeleteCartItem(index);
      },
      getOrderItemOptions: getOrderItemOptions,
      key: lineItemUuid,
      readOnly: readOnly,
      loading: loading
    });
  }) : /*#__PURE__*/React.createElement(EmptyCartMessage, null)), /*#__PURE__*/React.createElement("div", {
    className: "cart-total-summary-container"
  }, /*#__PURE__*/React.createElement(Divider, {
    section: true,
    horizontal: true,
    className: "cart-summary-divider"
  }), /*#__PURE__*/React.createElement(CartTotalSummary, {
    taxTotal: taxTotal,
    taxDetails: taxDetails,
    fulfillmentTotal: fulfillmentTotal,
    fulfillmentDetails: fulfillmentDetails,
    feeTotal: feeTotal,
    feeDetails: feeDetails,
    subTotal: subTotal,
    total: total,
    tip: tip,
    onTipChange: onTipChange
  })), !onSpecialInstructionsChange && readOnly && specialInstructions && /*#__PURE__*/React.createElement("div", {
    className: "cart-special-instructions-summary-container"
  }, /*#__PURE__*/React.createElement(Divider, {
    section: true,
    horizontal: true,
    className: "cart-summary-divider"
  }), /*#__PURE__*/React.createElement(SpecialInstructionsSummary, {
    specialInstructions: specialInstructions
  })), onSpecialInstructionsChange && readOnly && /*#__PURE__*/React.createElement(SpecialInstructions, {
    specialInstructions: cart === null || cart === void 0 ? void 0 : cart.instructions,
    onSpecialInstructionsChange: onSpecialInstructionsChange
  }), children);
}
CartSummary.defaultProps = defaultProps;
export default CartSummary;